export default __webpack_public_path__ + "static/media/plain-sticker-u.383463a7.png";